angular.module('impactx.MenuDirectives').directive('ixMessageTodo', function () {
    return {
        restrict: 'A',
        templateUrl: 'shared/menu/templates/messagetodo-menu.tmpl.html'
    }
});